var map = {
	"./arrow_down_icon.svg": "4a20",
	"./battery_empty.svg": "06ac",
	"./battery_high.svg": "d42e",
	"./battery_low.svg": "ef50",
	"./battery_middle.svg": "e968",
	"./battery_unknown.svg": "253d",
	"./checked_icon.svg": "b685",
	"./cloudy_icon.svg": "386f",
	"./cold.svg": "f4c2",
	"./flame_disabled_icon.svg": "869c",
	"./flame_icon.svg": "eb1b",
	"./info_icon.svg": "16fe",
	"./log.svg": "8430",
	"./moon_icon.svg": "b84c",
	"./pause.svg": "644b",
	"./pencil_icon.svg": "4de7",
	"./play.svg": "dab1",
	"./plug.svg": "1758",
	"./plug_x.svg": "2338",
	"./sun_icon.svg": "f70d",
	"./sun_white.svg": "86e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";